import angular from 'angular';
import { Lang } from 'Roblox';

let socialLinksConfiguration = angular.module("socialLinksConfiguration", ["robloxApp", "socialLinksCommon", "socialLinksConfigurationHtmlTemplateApp", "systemFeedback"])
    .config(["languageResourceProvider", function (languageResourceProvider) {
        languageResourceProvider.setLanguageKeysFromFile(Lang.PromotedChannelsResources);
    }]);

export default socialLinksConfiguration; 